import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faJava,
  faPython,
  faAndroid,
  faJs,
  faReact,
} from '@fortawesome/free-brands-svg-icons'
import { faDatabase } from '@fortawesome/free-solid-svg-icons'
import FadeInSection from '../FadeInSection'
import './index.scss'

const About = () => {
  return (
    <section id="about" className="about-section">
      <FadeInSection>
        <div className="section-header">
          <span className="section-title">/ about me</span>
        </div>
        <div className="about-content">

          <div className="about-description">
            <p>
              Hi! I'm <b>Akshata Dhuraji</b>, a Software Engineer currently
              working at{' '}
              <a href="https://hubsystems.com.au" target="_blank" rel="noreferrer">
                Hub Systems
              </a>
              . I'm passionate about all things tech — my interests span web
              development, mobile app development, and system design.
            </p>
            <p>
              I'm passionate about seeing more female representation in tech.
              Most of my side projects are showcased in the Projects section or
              on my{' '}
              <a href="https://github.com/akshataxx" target="_blank" rel="noreferrer">
                GitHub
              </a>
              . Feel free to reach out anytime via the contact form or{' '}
              <a href="https://www.linkedin.com/in/akshatadhuraji/" target="_blank" rel="noreferrer">
                LinkedIn
              </a>
              .
            </p>
            <p>
              The languages and technologies I work with are shown on the cube →
            </p>
          </div>

          <div className="about-image-col">
            <div className="stage-cube-cont" aria-hidden="true">
              <div className="cubespinner">
                <div className="face1"><FontAwesomeIcon icon={faJava} /></div>
                <div className="face2"><FontAwesomeIcon icon={faJs} /></div>
                <div className="face3"><FontAwesomeIcon icon={faDatabase} /></div>
                <div className="face4"><FontAwesomeIcon icon={faReact} /></div>
                <div className="face5"><FontAwesomeIcon icon={faAndroid} /></div>
                <div className="face6"><FontAwesomeIcon icon={faPython} /></div>
              </div>
            </div>
          </div>

        </div>
      </FadeInSection>
    </section>
  )
}

export default About
